import React from "react";

export interface RoundedQuestionBoxProps {
  startIndex: React.ReactNode | number | string;
  indexCenter?: boolean;
  children: React.ReactNode;
  scaleOnHover?: boolean;
  isOpen?: boolean;
  onClick?: () => void;
  color?: "primary" | "emerald" | "slate";
}
export const RoundedQuestionBox = ({
  isOpen,
  children,
  startIndex,
  indexCenter,
  scaleOnHover,
  onClick,
  color = "primary",
}: RoundedQuestionBoxProps) => {
  const scaleClass = scaleOnHover && !isOpen ? "hover:scale-105 transition-transform duration-200" : "";
  const isOpenClass = isOpen ? "rounded-t-xl" : "rounded-xl border border-slate-300 dark:border-slate-700";
  const isOpenIndexClass = isOpen ? "rounded-tl-xl" : "rounded-l-xl";
  return (
    <div
      className={`bg-white flex shadow-lg min-h-[74px] hover:bg-slate-50 dark:bg-slate-800 dark:hover:bg-slate-700/60 cursor-pointer ${isOpenClass} ${scaleClass}`}
      onClick={onClick}
    >
      <div
        className={`${colorClasses[color]} px-4 ${isOpenIndexClass} text-white w-[50px] flex justify-center ${
          indexCenter ? "items-center" : "pt-4"
        }`}
      >
        {startIndex}
      </div>
      <div className="py-4 px-4 flex w-full min-w-0 gap-4">{children}</div>
    </div>
  );
};

const colorClasses = {
  primary: "bg-primary-500 dark:bg-primary-600",
  emerald: "bg-emerald-500 dark:bg-emerald-600",
  slate: "bg-slate-500 dark:bg-slate-600",
};
